import { createSelector } from "reselect";

const selectCanaryVersionEnabled = (state) => state?.canaryVersion.enabled;

const canaryVersionSelector = (state) => state?.canaryVersion;

const selectCanaryVersion = createSelector(
  canaryVersionSelector,
  (canaryVersion) => canaryVersion?.version
);

export {
  selectCanaryVersionEnabled,
  canaryVersionSelector,
  selectCanaryVersion,
};
